import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { usePostHog } from "posthog-js/react";
import { useUser } from "../hooks/useUser";
import { ChevronLeft, X } from "../components/icons";
import wren1 from "../assets/wren-1.jpeg";
import wren2 from "../assets/wren-2.jpeg";
import wren3 from "../assets/wren-3.jpeg";
import wren4 from "../assets/wren-4.jpeg";

const birdImages = [wren1, wren2, wren3, wren4];

export function BirdPickerPage() {
  const navigate = useNavigate();
  const posthog = usePostHog();
  const { data: user } = useUser();

  const partnerName = user?.partner_name || "your partner";

  const handleSelectBird = useCallback((index: number) => {
    console.log("[PostHog] capture bird_selected", { bird_index: index });
    posthog?.capture("bird_selected", { bird_index: index });
    navigate("/");
  }, [navigate, posthog]);

  return (
    <div className="min-h-screen-safe flex flex-col bg-[#F8F8F6]">
      <div className="max-w-md mx-auto w-full flex-1">
        <header className="flex items-center justify-between px-2 py-4">
          <button
            onClick={() => navigate("/")}
            className="w-10 h-10 flex items-center justify-center text-text-primary"
            aria-label="Go back"
          >
            <ChevronLeft className="w-6 h-6" />
          </button>
          <button
            onClick={() => navigate("/")}
            className="w-10 h-10 flex items-center justify-center text-text-primary"
            aria-label="Close"
          >
            <X className="w-6 h-6" />
          </button>
        </header>

        <div className="px-6">
          {/* Heading */}
          <h1 className="font-serif text-2xl text-text-primary mb-6">
            Which Wren is {partnerName} most like?
          </h1>

          {/* 2x2 bird grid */}
          <div className="grid grid-cols-2 gap-4">
            {birdImages.map((src, index) => (
              <button
                key={index}
                onClick={() => handleSelectBird(index)}
                className="aspect-square rounded-2xl overflow-hidden shadow-[0px_1px_10px_0px_rgba(0,0,0,0.1)]"
              >
                <img
                  src={src}
                  alt={`Wren ${index + 1}`}
                  className="w-full h-full object-cover"
                />
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
